import { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { strCode } from "../../../../../consts";
import { t } from "../../../../../services";
import { useDebounce } from "../../../../../hooks";

import { FlexContainers, Input, WrapperContainer } from "../../../../../components";

export const LocalizationForm = ({ config, configErrors, languageListLength, onChange }) => {
  const [title, setTitle] = useState("");
  const [bodyText, setBodyText] = useState("");

  useEffect(() => {
    setTitle(config?.title ?? "");
    setBodyText(config?.bodyText ?? "");
  }, [config]);

  const saveConfig = () => {
    const newConfig = { title, bodyText };
    onChange(newConfig);
  };

  useDebounce(saveConfig, 100, title, bodyText, languageListLength);

  return (
    <WrapperContainer Container={FlexContainers.FlexColumnStart} gap={16} width={"100%"}>
      <Input
        id={"title"}
        title={t(strCode.TITLE)}
        value={title}
        setValue={setTitle}
        placeholder={t(strCode.TITLE_PLACEHOLDER)}
        maxLength={40}
        hasError={configErrors?.title}
        showLengthCounter
      />

      <Input
        id={"bodyText"}
        title={t(strCode.BODY_TITLE)}
        value={bodyText}
        setValue={setBodyText}
        placeholder={t(strCode.BODY_PLACEHOLDER)}
        maxLength={85}
        hasError={configErrors?.bodyText}
        showLengthCounter
      />
    </WrapperContainer>
  );
};

LocalizationForm.propTypes = {
  config: {
    title: PropTypes.string.isRequired,
    bodyText: PropTypes.string.isRequired
  },
  configErrors: PropTypes.shape({
    language: PropTypes.string.isRequired,
    title: PropTypes.bool.isRequired,
    bodyText: PropTypes.bool.isRequired
  }),
  languageListLength: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired
};
